import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryInput, CountryResult, GetCountriesInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private httpClient: HttpClient) { }

  public addCountry(countryInput: CountryInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Country/AddCountry', countryInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editCountry(id: number, countryInput: CountryInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Country/EditCountry?id=' + id, countryInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteCountry(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Country/DeleteCountry?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getCountries(getCountriesInput: GetCountriesInput, token: string): Promise<ResultList<CountryResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Country/GetCountries', getCountriesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CountryResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CountryResult>(), result.error));
  }
}
